module.exports = __webpack_public_path__ + "static/media/CREATIVIDAD(B).77437ed8.svg";